export const theme = {
    
    fontFamily: 'GT Flexa, sans-serif',
    colorScheme: 'light',
    headings: { 
        fontFamily: 'GT Flexa, sans-serif',
        fontWeight: '600'
    },
    colors: {
      'red': ['#fde3e6','#fac3c8','#f7a3ab','#f4828d','#f16270','#ee4152','#eb2135','#c91c2d','#a61726','#84131e'],
      'blueStone': ['#ccdee0', '#99bdc2', '#669da3', '#337c85', '#005b66', '#00525c', '#00525c', '#005b66', '#004952','#001214' ]
    },
    primaryColor: 'blueStone',
    spacing: { xs: 5, sm: 10, md: 20, lg: 30, xl: 40 }
    
}